(function() {
    "use strict";

    angular.module("eSign")
      .controller("ChooseSignTaskController", ['$scope', '$http', '$window', 'signTaskService', 'sessionService', 'appConfig', function($scope, $http, $window, signTaskService, sessionService, appConfig){

            $scope.applications = [];
            $scope.isLoading = true;
          $scope.signTaskNotReadyToSign = false;
          $scope.signedApplications = [];
          
        // Redirect to document list page when a signtask is selected.
		  $scope.openSignTask = function(application) {
              sessionService.setCurrentApplicationNumber(application.applicationNumber, application.offerInsurance).then(function (response) {
                  if (application.requiresJobTitle) $window.location = appConfig.customerUrl;
                  else $window.location = appConfig.chooseDocumentUrl;
          });
          };

          // Sending a rejection call to the appliction.
		  $scope.deleteSignTask = function (application) {
            signTaskService.rejectSignTask(application.applicationNumber).then(function(response) {
            var success = response.data;
            if(success == true) {
                getSignTasksFromDocHub();
            } else {
                $window.alert("Kunne ikke slette avtalen");
            }
          });
        };

          $scope.downloadDocument = function (document) {
              $window.open(signTaskService.getSignedDocumentURL(document.reference, document.signTaskId), '_blank');
          }

		var getSignTaskNotReadyToSign = function () {
			signTaskService.getSignTaskNotReadyToSign().then(function (response) {
				$scope.signTaskNotReadyToSign = response.data;
			});
		};

        // Checking if the user have any sign tasks. If not redirect to another page for information
        var getSignTasksFromDocHub = function() {
            signTaskService.getActiveSignTasks().then(function (response) {
                $scope.isLoading = false;
                $scope.applications = response.data.signTasks;
                $scope.signedApplications = response.data.signedSignTasks;

	            getSignTaskNotReadyToSign();

                if ($scope.applications.length == 0 && $scope.signedApplications.length == 0) {
                    $window.location = appConfig.noSignTasksUrl;
                }
          });
        };

        // fetching the documents
        getSignTasksFromDocHub();
    }]);
}());
